import Conference from './components/Conference';

export default Conference;
